import React from "react";
import PropTypes from "prop-types";
import {
  P2,
  P20,
  P200,
  P1000,
  TIP_S,
  TIP_M,
  TIP_L,
  PIPETTE_TIP_CHART,
  PIPETTE_BODY_COLOR_CHART,
} from "../MicroPipette.constants";

/**
 * PipetteBody:
 *  - Component that display the Main body of MicroPipette
 */
export function PipetteBody(props) {
  const PIPETTE_TIPS = {
    [TIP_S]: (
      <g
        xmlns="http://www.w3.org/2000/svg"
        style={{
          "clip-path": `url(#clip2_1_963_${props.type})`,
          "-webkit-clip-path": `url(#clip2_1_963_${props.type})`,
        }}
      >
        <rect
          opacity="0.8"
          x="7.52715"
          y="186.945"
          width="10"
          height="1"
          transform="rotate(0.314367 7.52715 186.945)"
          fill="white"
        />
        <mask
          id="mask1_1_963"
          style={{ "mask-type": "alpha" }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="186"
          width="10"
          height="41"
        >
          <path
            opacity="0.8"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.02715 186.948L17.027 186.997L16.4667 197.995L16.1333 197.993L15.9393 202.992L15.3592 202.989L13.3076 226.978L11.3076 226.967L9.51933 202.956L8.93939 202.953L8.80016 197.952L8.46678 197.951L8.02715 186.948Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1_963)">
          <path
            opacity="0.8"
            d="M8.02715 186.948L17.027 186.997L16.4667 197.995L8.46678 197.951L8.02715 186.948Z"
            fill="white"
          />
          <path
            opacity="0.8"
            d="M8.77232 196.952L16.1722 196.993L15.9393 202.992L8.93939 202.953L8.77232 196.952Z"
            fill="white"
          />
          <path
            opacity="0.8"
            d="M9.44482 201.956L15.4447 201.989L13.3076 226.978L11.3076 226.967L9.44482 201.956Z"
            fill="white"
          />
          <rect
            opacity="0.8"
            x="11.3076"
            y="226.967"
            width="2"
            height="1"
            transform="rotate(0.314367 11.3076 226.967)"
            fill="white"
          />
          <path
            opacity="0.9"
            d="M10.4448 201.962L11.6076 226.968L11.3076 226.967L9.53933 202.957L8.93934 202.953L8.76678 197.952L8.46678 197.951L8.02166 187.948L9.52438 187.456L10.4448 201.962Z"
            fill="white"
          />
          <path
            opacity="0.9"
            d="M14.4447 201.983L13.0076 226.976L13.3076 226.978L15.3392 202.988L15.9392 202.992L16.1667 197.993L16.4667 197.995L17.0215 187.997L15.5243 187.489L14.4447 201.983Z"
            fill="white"
          />
          <path
            opacity="0.1"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5215 188L7.69116 187.946L7.51618 188.945L17.4821 189L17.5215 188ZM8.61933 197.951L17.4666 198L17.4307 199L8.4613 198.951L8.61933 197.951ZM9.53934 202.957L15.3392 202.988L15.3138 203.988L9.43385 203.956L9.53934 202.957Z"
            fill="#333333"
          />
        </g>
        <path
          opacity="0.7"
          d="M14.3269 205L10.7268 205L11.8269 227L13.2269 227L14.3269 205Z"
          fill={props.solution}
        />
        <defs xmlns="http://www.w3.org/2000/svg">
          <clipPath
            xmlns="http://www.w3.org/2000/svg"
            id={`clip2_1_963_${props.type}`}
          >
            <rect
              width="10"
              height="63.9999"
              fill="white"
              transform="translate(7.52686 187)"
            />
          </clipPath>
        </defs>
      </g>
    ),
    [TIP_M]: (
      <g
        xmlns="http://www.w3.org/2000/svg"
        style={{
          "clip-path": `url(#clip2_1_965_${props.type})`,
          "-webkit-clip-path": `url(#clip2_1_965_${props.type})`,
        }}
      >
        <path
          opacity="0.8"
          d="M7.52686 187L17.5269 187L17.5269 189L7.52686 189L7.52686 187Z"
          fill="#F7EFC7"
        />
        <mask
          id="mask1_1_965"
          style={{ "mask-type": "alpha" }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="187"
          width="10"
          height="65"
        >
          <path
            opacity="0.8"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.02704 187L17.0271 187L16.5271 204L15.9779 204L15.527 213L14.9886 213L13.527 251.004L11.527 251.001L10.0656 213L9.52697 213L9.07709 204L8.52704 204L8.02704 187Z"
            fill="#F7EFC7"
          />
        </mask>
        <g mask="url(#mask1_1_965)">
          <path
            opacity="0.8"
            d="M7.52731 187.027L17.5272 186.972L17.0649 203.975L8.17613 204.024L7.52731 187.027Z"
            fill="#F7EFC7"
          />
          <path
            opacity="0.8"
            d="M7.61508 203.027L17.6149 202.972L17.3996 212.973L7.94022 213.025L7.61508 203.027Z"
            fill="#F7EFC7"
          />
          <path
            opacity="0.8"
            d="M9.66446 212.016L15.6644 211.983L13.8784 250.993L11.8784 251.004L9.66446 212.016Z"
            fill="#F7EFC7"
          />
          <path
            d="M12.0269 251.001L10.0328 188.013L8.03279 188.024L7.52717 251.01L12.0269 251.001Z"
            fill="#F7EFC7"
          />
          <path
            d="M13.027 250.996L15.0327 187.986L17.0326 187.975L17.527 250.996L13.027 250.996Z"
            fill="#F7EFC7"
          />
          <path
            opacity="0.2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5273 189L7.52707 189L7.53854 190.027L17.5271 190L17.5273 189ZM7.77312 204.026L16.6204 203.977L16.5954 204.978L7.62606 205.027L7.77312 204.026ZM9.76993 213.015L15.5698 212.983L15.5553 213.983L9.67541 214.016L9.76993 213.015Z"
            fill="#333333"
          />
        </g>
        <path
          opacity="0.7"
          d="M14.1268 216L10.9268 216L12.0268 251L13.0268 251L14.1268 216Z"
          fill={props.solution}
        />
        <defs xmlns="http://www.w3.org/2000/svg">
          <clipPath
            xmlns="http://www.w3.org/2000/svg"
            id={`clip2_1_965_${props.type}`}
          >
            <rect
              width="10"
              height="64"
              fill="white"
              transform="translate(7.52686 187)"
            />
          </clipPath>
        </defs>
      </g>
    ),
    [TIP_L]: (
      <g
        xmlns="http://www.w3.org/2000/svg"
        style={{
          "clip-path": `url(#clip2_1_967_${props.type})`,
          "-webkit-clip-path": `url(#clip2_1_967_${props.type})`,
        }}
      >
        <path
          opacity="0.8"
          d="M7.52686 187L17.5269 187L17.5269 189L7.52686 189L7.52686 187Z"
          fill="#C6EDFC"
        />
        <mask
          id="mask1_1_967"
          style={{ "mask-type": "alpha" }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="187"
          width="10"
          height="65"
        >
          <path
            opacity="0.8"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.02704 187L17.0271 187L16.5271 204L15.9779 204L15.527 213L14.9886 213L13.527 251.004L11.527 251.001L10.0656 213L9.52697 213L9.07709 204L8.52704 204L8.02704 187Z"
            fill="#C6EDFC"
          />
        </mask>
        <g mask="url(#mask1_1_967)">
          <path
            opacity="0.7"
            d="M7.52728 187.027L17.5271 186.972L17.0649 203.975L8.1761 204.024L7.52728 187.027Z"
            fill="#C6EDFC"
          />
          <path
            opacity="0.7"
            d="M7.61511 203.027L17.615 202.972L17.3996 212.973L7.94025 213.025L7.61511 203.027Z"
            fill="#C6EDFC"
          />
          <path
            opacity="0.7"
            d="M9.66443 212.016L15.6643 211.983L13.8784 250.993L11.8784 251.004L9.66443 212.016Z"
            fill="#C6EDFC"
          />
          <path
            opacity="0.7"
            d="M12.027 251.001L10.0328 188.013L8.03282 188.024L7.5272 251.01L12.027 251.001Z"
            fill="#C6EDFC"
          />
          <path
            opacity="0.7"
            d="M13.0271 250.996L15.0327 187.986L17.0327 187.975L17.5271 250.996L13.0271 250.996Z"
            fill="#C6EDFC"
          />
          <path
            opacity="0.2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5273 189L7.5271 189L7.53857 190.027L17.5271 190L17.5273 189ZM7.77315 204.026L16.6205 203.977L16.5955 204.978L7.62609 205.027L7.77315 204.026ZM9.76996 213.015L15.5699 212.983L15.5554 213.983L9.67544 214.016L9.76996 213.015Z"
            fill="#333333"
          />
        </g>
        <path
          opacity="0.7"
          d="M14.1269 216L10.9269 216L12.0269 251L13.0269 251L14.1269 216Z"
          fill={props.solution}
        />
        <defs xmlns="http://www.w3.org/2000/svg">
          <clipPath id={`clip2_1_967_${props.type}`}>
            <rect
              width="10"
              height="64"
              fill="white"
              transform="translate(7.52686 187)"
            />
          </clipPath>
        </defs>
      </g>
    ),
  };

  const getTip = () => {
    const tipType = PIPETTE_TIP_CHART[props.type];
    return PIPETTE_TIPS[tipType];
  };

  const attachTip = () => {
    if (props.hasTip) return getTip();
    else return null;
  };

  const color = PIPETTE_BODY_COLOR_CHART[props.type];

  return (
    <svg
      className={props.className}
      width="25"
      height="253"
      viewBox="0 0 25 253"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={props.ariaLabel}
    >
      <g
        style={{
          "clip-path": `url(#clip1_1_966_${props.type})`,
          "-webkit-clip-path": `url(#clip1_1_966_${props.type})`,
        }}
      >
        <path
          d="M15.1684 192.673L10.0791 192.673C9.81125 192.673 9.59687 192.419 9.59676 192.102L9.59406 184.673L15.5941 184.673L15.5968 192.102C15.5969 192.419 15.3827 192.673 15.1684 192.673Z"
          fill="#99B2C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.58787 167.673C8.58787 167.673 8.00596 138.873 4.5715 122.673L12.5715 122.673L20.5715 122.673C17.1488 138.873 16.5879 167.673 16.5879 167.673L16.5948 186.673C16.5952 187.778 15.7001 188.673 14.5955 188.673L10.5955 188.673C9.49094 188.673 8.59519 187.778 8.59478 186.673L8.58787 167.673Z"
          fill="#E5ECF0"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5657 106.673L2.56567 106.673L2.5715 122.673C2.5719 123.778 7.04938 124.673 12.5722 124.673C18.0951 124.673 22.5719 123.778 22.5715 122.673L22.5657 106.673Z"
          fill="#CCD8E1"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.5637 109.627L24.5339 27.6729C24.5333 26.2654 23.7789 25.5797 22.5446 24.9765L18.1558 22.8318L12.6013 20.218L6.43174 23.1669L2.59291 24.9765C1.29044 25.5797 0.536692 26.786 0.537204 28.1935L0.566855 109.673C0.567257 110.777 5.94017 111.673 12.5676 111.673C19.195 111.673 24.5673 110.777 24.5669 109.673C24.5668 109.657 24.5658 109.642 24.5637 109.627Z"
          fill="#F5F7F9"
        />
        <mask
          id={`mask0_1_966_${props.type}`}
          style={{ "mask-type": "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="20"
          width="25"
          height="92"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.5637 109.627L24.5339 27.6729C24.5333 26.2654 23.7789 25.5797 22.5446 24.9765L18.1558 22.8318L12.6013 20.218L6.43174 23.1669L2.59291 24.9765C1.29044 25.5797 0.536692 26.786 0.537204 28.1935L0.566855 109.673C0.567257 110.777 5.94017 111.673 12.5676 111.673C19.195 111.673 24.5673 110.777 24.5669 109.673C24.5668 109.657 24.5658 109.642 24.5637 109.627Z"
            fill="#F5F7F9"
          />
        </mask>
        <g mask={`url(#mask0_1_966_${props.type})`}>
          <rect
            width="6"
            height="87"
            transform="matrix(1 1.11972e-09 0.000363905 1 0.535919 24.6729)"
            fill="#E5ECF0"
          />
          <rect
            width="6"
            height="87"
            transform="matrix(1 1.11972e-09 0.000363905 1 18.5359 24.6729)"
            fill="#E5ECF0"
          />
        </g>
        <path
          d="M12.601 20.6208C15.1759 20.6208 17.263 19.8106 17.2626 18.8113C17.2623 17.8119 15.1746 17.0017 12.5997 17.0017C10.0248 17.0017 7.93777 17.8119 7.93814 18.8113C7.9385 19.8106 10.0262 20.6208 12.601 20.6208Z"
          fill="#F5F7F9"
        />
        <path
          d="M21.3766 21.6925C20.0046 19.5478 17.8785 17.9394 15.4786 17.2692C14.9988 17.6043 13.9019 17.8053 12.5306 17.8053C11.2279 17.8053 10.1994 17.6043 9.65082 17.3362C7.25141 18.0734 5.05795 19.5478 3.6875 21.7595C3.20786 22.5638 3.00254 23.5691 3.00288 24.5073L3.00622 33.6891C3.00649 34.4263 3.69231 34.9625 4.44647 34.8955C6.70888 34.4934 9.38272 34.2253 12.3309 34.2253C15.4848 34.2253 18.2274 34.4934 20.6272 34.8955C21.3814 35.0295 22.0669 34.4934 22.0666 33.6891L22.0632 24.3733C22.0628 23.435 21.8568 22.4967 21.3766 21.6925Z"
          fill={color.color3}
        />
        <path
          d="M3.9667 23.2341C4.92611 21.9607 6.29702 21.0224 7.73656 20.2852C8.49063 19.9501 9.24472 19.682 10.0674 19.481C10.8901 19.2799 11.7128 19.2129 12.5355 19.2129C14.181 19.2129 15.8952 19.548 17.3353 20.2852C18.8439 20.9554 20.147 21.9607 21.1073 23.2341C19.7357 22.3628 18.3643 21.6926 16.9243 21.2235C16.17 21.0224 15.4843 20.8214 14.7301 20.6873C13.9758 20.5533 13.2216 20.4863 12.4674 20.4863C10.9591 20.4863 9.45079 20.7543 8.01113 21.1565C6.70864 21.6926 5.26907 22.3628 3.9667 23.2341Z"
          fill={color.color4}
        />
        <path
          d="M16.5473 56.0001L8.54732 56.0001L8.55751 84L16.5575 84L16.5473 56.0001Z"
          fill={color.color3}
        />
        <path
          d="M14.8771 61.306L10.3188 61.306L10.3247 77.5316L14.883 77.5316L14.8771 61.306Z"
          fill="#FBF9DE"
        />
        <path
          d="M14.8771 61.306L10.3188 61.306L10.3189 61.6422L14.8772 61.6422L14.8771 61.306Z"
          fill={color.color2}
        />
        <path
          d="M14.8829 77.2794L10.3246 77.2794L10.3247 77.6156L14.883 77.6156L14.8829 77.2794Z"
          fill={color.color2}
        />
        <path
          d="M14.8809 71.9827L10.3227 71.9827L10.3228 72.3189L14.8811 72.3189L14.8809 71.9827Z"
          fill={color.color2}
        />
        <path
          d="M14.879 66.6022L10.3207 66.6022L10.3208 66.9385L14.8791 66.9385L14.879 66.6022Z"
          fill={color.color2}
        />
        <path
          d="M12.5534 67.5C12.9339 67.5 13.2355 67.6656 13.4582 67.9968C13.6827 68.3281 13.795 68.7807 13.7952 69.3547C13.7955 69.9339 13.6852 70.3908 13.4646 70.7255C13.2439 71.0602 12.9425 71.2275 12.5602 71.2275C12.1725 71.2275 11.8655 71.0619 11.6392 70.7307C11.4147 70.3977 11.3024 69.9425 11.3022 69.3651C11.302 68.7893 11.414 68.335 11.6382 68.002C11.8625 67.6673 12.1675 67.5 12.5534 67.5ZM12.0022 69.3859C12.0025 70.2165 12.1866 70.6319 12.5546 70.6319C12.9135 70.6319 13.0929 70.1949 13.0925 69.3208C13.0922 68.5041 12.9108 68.0957 12.5483 68.0957C12.1839 68.0957 12.0019 68.5257 12.0022 69.3859Z"
          fill="#101620"
        />
        <path
          d="M12.5625 73C12.943 73 13.2446 73.1656 13.4673 73.4968C13.6918 73.8281 13.8041 74.2807 13.8043 74.8547C13.8045 75.4339 13.6943 75.8908 13.4737 76.2255C13.253 76.5602 12.9515 76.7275 12.5692 76.7275C12.1815 76.7275 11.8746 76.5619 11.6483 76.2307C11.4238 75.8977 11.3115 75.4425 11.3113 74.8651C11.311 74.2893 11.4231 73.835 11.6473 73.502C11.8715 73.1673 12.1766 73 12.5625 73ZM12.0113 74.8859C12.0116 75.7165 12.1957 76.1319 12.5636 76.1319C12.9226 76.1319 13.1019 75.6949 13.1016 74.8208C13.1013 74.0041 12.9199 73.5957 12.5573 73.5957C12.193 73.5957 12.011 74.0257 12.0113 74.8859Z"
          fill="#101620"
        />
        <path
          d="M21.9969 24.7083L22.0001 33.689C22.0004 34.4262 21.3835 34.9624 20.5607 34.8283C19.8065 34.6943 18.9837 34.6273 18.0924 34.4932L18.0882 23.0998C19.1854 23.5019 19.8026 23.837 20.7626 24.2391C21.5168 24.4402 21.5168 24.4402 21.9969 24.7083Z"
          fill={color.color1}
        />
        <path
          d="M3.07297 24.7103L3.07624 33.6911C3.07651 34.4283 3.69377 34.9645 4.51647 34.8304C5.2706 34.6964 6.09333 34.6294 6.98459 34.4953L6.98044 23.1019C5.88359 23.504 5.26665 23.8391 4.30693 24.2412C3.55281 24.4423 3.55281 24.4423 3.07297 24.7103Z"
          fill={color.color1}
        />
        <path
          d="M13.0605 65.2709L13.8855 65.2709L13.8857 65.8009L11.6357 65.8009L11.6355 65.2709L12.4605 65.2709L12.4598 63.1559C12.1748 63.2909 11.8548 63.3209 11.5348 63.3259L11.5346 62.8409C11.9896 62.8259 12.2796 62.7009 12.4895 62.4009L13.0595 62.4009L13.0605 65.2709Z"
          fill="#DB0300"
        />
        {attachTip()}
      </g>
      <defs>
        <clipPath id={`clip1_1_966_${props.type}`}>
          <rect
            width="24"
            height="253"
            fill="white"
            transform="matrix(1 1.11972e-09 0.000363905 1 0.526855 0.00012207)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

PipetteBody.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Type of MicroPipette
   */
  type: PropTypes.oneOf([P2, P20, P200, P1000]),
  /**
   * Boolean to mark if tip attached
   */
  hasTip: PropTypes.bool,
  /**
   * Color value for solution in PipetteTip
   */
  solutioon: PropTypes.string,
};

PipetteBody.defaultProps = {
  className: "",
  type: P2,
  hasTip: false,
  solution: "",
};
